import { getUserInfo } from "../socket/events.js";
import { getPeer } from "./players.js";

const uidState = new Map(); // uid -> { username, color, avatar, target }
const targetMembers = new Map(); // targetName -> Map<uid, { username, color, avatar }>

let onChange = () => {};
export const setOnPresenceChange = (cb) => {
    onChange = typeof cb === "function" ? cb : () => {};
};

const removeFromCurrentTarget = (uid) => {
    const prev = uidState.get(uid);
    if (!prev?.target) return;
    const members = targetMembers.get(prev.target);
    if (!members) return;
    members.delete(uid);
    if (members.size === 0) targetMembers.delete(prev.target);
};

const setUserTarget = (uid, username, color, avatar, target) => {
    removeFromCurrentTarget(uid);
    uidState.set(uid, { username, color, avatar, target });

    if (target) {
        if (!targetMembers.has(target)) targetMembers.set(target, new Map());
        targetMembers.get(target).set(uid, { username, color, avatar });
    }
};

export const getTargetMembers = (targetName) => {
    const members = targetMembers.get(targetName);
    return members ? Array.from(members.values()) : [];
};

export const getActiveTargets = () => Array.from(targetMembers.keys());

export const onSpriteFocus = (data) => {
    if (!data?.uid || data.uid === getUserInfo().uid) return;
    setUserTarget(
        data.uid,
        data.username,
        data.color,
        getPeer(data.uid)?.avatar ?? null,
        data.data?.target ?? null,
    );
    onChange();
};

export const onPresencePlayersUpdate = (players) => {
    const activeUids = new Set();

    for (const p of players || []) {
        if (!p?.uid || p.uid === getUserInfo().uid) continue;
        activeUids.add(p.uid);
        if (!uidState.has(p.uid)) {
            setUserTarget(
                p.uid,
                p.username,
                p.color,
                p.avatar ?? null,
                p.currentTarget ?? null,
            );
        }
    }

    for (const uid of Array.from(uidState.keys())) {
        if (!activeUids.has(uid)) {
            removeFromCurrentTarget(uid);
            uidState.delete(uid);
        }
    }

    onChange();
};
